var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14,
    r: 13.5,
    stroke: "#FDFCF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.86 17.68H12.1a6.83 6.83 0 0 0-6.8 6.27.4.4 0 0 0 .4.45c.21 0 .4-.17.42-.37a6 6 0 0 1 5.98-5.54h4.78a6.04 6.04 0 0 1 6 5.52c.02.2.19.37.41.37a.4.4 0 0 0 .41-.45 6.87 6.87 0 0 0-6.84-6.25Zm-2.38-2.49a4.78 4.78 0 1 0-.01-9.56 4.78 4.78 0 0 0 .01 9.56Zm0-8.75a3.96 3.96 0 1 1 0 7.92 3.96 3.96 0 0 1 0-7.92Z",
    fill: "#FDFCF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bdf1c818df87d2a8ac574e2c3bc4bed8.svg";
export { ForwardRef as ReactComponent };